
import { useTranslation } from 'react-i18next';

export default function IntroductionSection() {
  const { t } = useTranslation();

  return (
    <>
      <div className="hidden md:block text-center bg-blue-900 text-white py-[min(10vw,10rem)] font-extralight items-center">
        <div className="tracking-[1px] max-w-full mx-auto px-4">
          <span className="md:whitespace-nowrap w-full">
            <span className="tracking-[10px] text-[min(1.5vw,1.5rem)]">{t('introduction.line1')}</span>
            <br />
            <span className="text-orange-500 font-semibold text-[min(3vw,3rem)] tracking-[10px]">
              {t('introduction.line2')}
            </span>
          </span>
        </div>
      </div>
      
      <div className="block md:hidden text-center bg-blue-900 text-white py-[min(10vw,10rem)] font-extralight items-center">
        <div className="tracking-[1px] max-w-full mx-auto">
          <span className="md:whitespace-nowrap w-full">
            <span className="tracking-[6px] text-[min(2.5vw,2.5rem)]">{t('introduction.line1')}</span>
            <br />
            <span className="text-orange-500 font-semibold text-[min(3.5vw,3.5rem)] text-nowrap tracking-[4px]">
              {t('introduction.line2')}
            </span>
          </span>
        </div>
      </div>
    </>
  );
}
